import script from "./ContentItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentItem.vue?vue&type=script&setup=true&lang=ts"

import "./ContentItem.vue?vue&type=style&index=0&id=543cde94&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-543cde94"]])

export default __exports__